// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"b3c5ba4d8dbe08edc7ca","777":"9d2d2b8b9fe346aebeba"}[chunkId] + ".js";
};